import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import APIUrl from "../../APIUrl";
import AutoSuggestProducts from "../sub/AutoSuggestProducts";
import ProductsParserUtil from "../../util/ProductsParserUtil";
import { Link } from "react-router-dom";
import { getProducts } from "../../actions/products/products";
import "../../css/families/families.css";
import TableToolbar from "../sub/bootstrap/TableToolbar";

class Families extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popSugg: false,
    };
  }

  getDesignation(product) {
    if (!product.designation) return product.sous_famille;

    if (
      product.designation.indexOf(process.env.REACT_APP_PRODUCT_DELIMITER) === 0
    )
      return product.designation;

    return product.designation.split(
      process.env.REACT_APP_PRODUCT_DELIMITER,
    )[0];
  }

  onSearch(value, products, mercurialId) {
    // Find the product and redirect to it
    for (let product of products) {
      if (product.ref === value.ref && product.mercurial_id === mercurialId) {
        // Déterminer si c'est une famille de location
        const isRentalFamily =
          product.famille && product.famille.toLowerCase().includes("location");
        const basePath = isRentalFamily
          ? "#/home/rentals/mercurial/"
          : "#/home/products/mercurial/";

        window.location.href =
          basePath +
          product.mercurial_id +
          "/" +
          encodeURI(product.famille) +
          "/" +
          product._id;
      }
    }
  }

  productsToSuggestions(products) {
    var suggestions = [];
    var alreadyUsedFamilies = {};

    for (let product of products) {
      var sugg = ProductsParserUtil.trim(product);

      if (!sugg && !alreadyUsedFamilies[product.sous_famille]) {
        sugg = product.sous_famille;
        alreadyUsedFamilies[product.sous_famille] = true;
      }

      if (sugg) suggestions.push(sugg);
    }

    return suggestions;
  }

  componentDidMount() {
    if (
      this.props.mercurials.length !== 0 &&
      this.props.products.length !== this.props.mercurials.productsLength
    ) {
      this.props.onGetProducts();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.mercurials.length !== 0 &&
      this.props.products.length !== this.props.mercurials.productsLength &&
      prevProps.products.length !== this.props.products.length
    ) {
      this.props.onGetProducts();
    }
  }

  render() {
    // No 'families'? No render
    if (this.props.products.length === 0) {
      return (
        <div className="alert alert-secondary" role="alert">
          <FormattedMessage id="Empty.Families" />
        </div>
      );
    }

    let suggestions2 = [];
    let mercurial_id;

    let favoriteFamilyKey = this.props.intl
      .formatMessage({ id: "Top.Products" })
      .toUpperCase();
    let favoriteRentalFamilyKey = this.props.intl
      .formatMessage({ id: "Top.Rental.Products" })
      .toUpperCase();
    let familiesUniques = {};

    // Add dynamic favorite family for products
    familiesUniques[favoriteFamilyKey] = {
      mercurialId: null,
      fam: "0.FAV",
      isRentalFavorite: false,
    };
    // Add dynamic favorite family for rentals
    familiesUniques[favoriteRentalFamilyKey] = {
      mercurialId: null,
      fam: "0.FAV.RENTAL",
      isRentalFavorite: true,
    };

    this.props.products.forEach((product) => {
      let obj = {};
      obj.designation = ProductsParserUtil.swapDesignationDelimiter(
        product.designation,
      );
      obj.caracteristiques = product.caracteristiques;
      obj.ref = product.ref;
      obj.mercurial_id = product.mercurial_id;
      obj.ref_frn = product.ref_frn;
      obj.famille = product.famille;
      obj.sous_famille = product.sous_famille;
      suggestions2.push(obj);

      mercurial_id = product.mercurial_id;

      // define families
      familiesUniques[product.famille] = {
        mercurialId: product.mercurial_id,
        fam: product.fam,
      };
    });

    // Update favorite families to add mercurial_id defined in previous loop
    familiesUniques[favoriteFamilyKey] = {
      mercurialId: mercurial_id,
      fam: "0.FAV",
      isRentalFavorite: false,
    };
    familiesUniques[favoriteRentalFamilyKey] = {
      mercurialId: mercurial_id,
      fam: "0.FAV.RENTAL",
      isRentalFavorite: true,
    };

    let familiesNode = Object.keys(familiesUniques).map((famille) => {
      const familyData = familiesUniques[famille];
      const isFavoriteFamily =
        famille === favoriteFamilyKey || famille === favoriteRentalFamilyKey;

      // Href link - Déterminer l'image
      var imgSrc;
      if (famille === favoriteFamilyKey) {
        imgSrc = "/images/favorite_family.png";
      } else if (famille === favoriteRentalFamilyKey) {
        imgSrc = "/images/favorite_rental_family.png";
      } else {
        imgSrc =
          APIUrl.getFamilyImg +
          familyData.mercurialId +
          "/FAM_" +
          familyData.fam.split(".")[0] +
          "?token=" +
          APIUrl.jwtToken;
      }

      // Déterminer si la famille est une famille de location
      const isRentalFamily =
        familyData.isRentalFavorite ||
        famille.toLowerCase().includes("location");
      const basePath = isRentalFamily
        ? "/home/rentals/mercurial/"
        : "/home/products/mercurial/";

      // Pour les favoris de location, on utilise "Favoris" comme nom de famille dans l'URL
      const familleUrl = famille === favoriteRentalFamilyKey ? "Favoris" : famille;

      return (
        <div
          className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 mb-4 mx-auto mw-400"
          key={famille}
        >
          <Link
            to={
              basePath +
              familyData.mercurialId +
              "/" +
              encodeURI(familleUrl)
            }
            className="text-decoration-none"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <div className="card h-300">
              <div className="card-header text-center">
                <h6
                  className={isFavoriteFamily ? "text-success mb-0" : "text-info mb-0"}
                >
                  <strong>{famille}</strong>
                </h6>
              </div>
              <div className="h-350">
                <img
                  className="d-block align-middle mx-auto blocFamilies"
                  src={imgSrc}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      famille === favoriteRentalFamilyKey
                        ? "/images/favorite_family.png"
                        : "/images/no_image_512.png";
                  }}
                  alt=""
                />
              </div>
            </div>
          </Link>
        </div>
      );
    });

    var familles = [];
    var suggestions = [];
    var filteredProducts = [];
    var mercurialId = "";

    var establishmentSettings = this.props.establishmentSettings;

    if (establishmentSettings && establishmentSettings.mercurial_id) {
      filteredProducts = this.props.products.filter(
        (p) => p.mercurial_id === establishmentSettings.mercurial_id,
      );
      mercurialId = establishmentSettings.mercurial_id;
    }

    if (this.state.popSugg) {
      familles = Object.keys(familiesUniques);

      suggestions = suggestions.concat(familles);

      for (let famille of familles) {
        let ps = ProductsParserUtil.parseProducts(filteredProducts, famille);
        suggestions = suggestions.concat(this.productsToSuggestions(ps));
      }
    }

    return (
      <React.Fragment>
        <TableToolbar>
          <div className="mx-auto w-50">
            <AutoSuggestProducts
              id="search"
              name="search"
              onClick={(e) => this.setState({ popSugg: true })}
              onBlur={(e) => this.update("name", e.target.value)}
              onSuggestionSelected={(value) =>
                this.onSearch(value, filteredProducts, mercurialId)
              }
              suggestions={suggestions2}
              placeholder={"Search.Product.Placeholder"}
            />
          </div>
        </TableToolbar>

        <div className="row">{familiesNode}</div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.i18n.lang,
    products: state.products,
    mercurials: state.mercurials,
    establishmentSettings: state.establishmentSettings,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetProducts: () => dispatch(getProducts()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Families));
